import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const getHistoryOrderByOrderId = (orderId: number) =>
    createSelector(
        historyOrdersState,
        (historyOrders) => historyOrders?.orders?.find((order) => order.data != null && order.OrderId === orderId) || null
    );
